// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClientPanel-module__headerBox--caM2M {
    display: flex;
    gap: 30px;
    border-radius: 14px;
    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    padding: 10px;
    margin-top: 20px;
}

.ClientPanel-module__cardBox--GQihl {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 180px;
}

.ClientPanel-module__cardBoxInfo--wM8fh>span {
    color: #0054E6;
    font-size: 45px;
    font-weight: bold;
    margin-right: 10px;
}
.ClientPanel-module__cardBoxInfo--wM8fh {
    color: #0054E6;
    margin-bottom: 0;
}
.ClientPanel-module__sign--kXNwG {
    color: #5576ad;
    font-size: 35px;
    font-weight: bold;
    margin: 0;
     margin-right: 10px;
}
.ClientPanel-module__textDescription--zkwrT {
    display: flex;
    color: #4b5863;
    font-size: 15px;
    font-weight: bold;
}

.ClientPanel-module__claimContainer--EdIr_ {
    margin-top: 40px;
    display: flex;
    gap: 40px;
}

.ClientPanel-module__rightBox--ZRNWm {
     border-radius: 14px;
    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    padding: 20px;
}
.ClientPanel-module__rightBox--ZRNWm>.ClientPanel-module__textBox--WRZ9r {
    font-weight: bold;
}
.ClientPanel-module__textColor--g7w8P {
    color: #0054E6;
    font-size: 20px;
    text-align: center;
}

.ClientPanel-module__infoBox--nc8ga {
    margin: 20px 0;
    display: flex;
    gap: 20px;
    align-content: center;
    justify-content: center;
    align-items: center;
    background-color: #e6ebfc;
    border-radius: 20px;
    padding: 15px;
}

.ClientPanel-module__infoBox--nc8ga>div>p>span {
    font-weight: bold;
}

.ClientPanel-module__icon--OTied>svg {
    color: #0054E6;
    font-size: 35px;
}
`, "",{"version":3,"sources":["webpack://./src/features/statistics/ui/ClientPanel.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,2DAA2D;IAC3D,wDAAwD;IACxD,mDAAmD;IACnD,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,SAAS;KACR,kBAAkB;AACvB;AACA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;AACb;;AAEA;KACK,mBAAmB;IACpB,2DAA2D;IAC3D,wDAAwD;IACxD,mDAAmD;IACnD,aAAa;AACjB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB","sourcesContent":[".headerBox {\r\n    display: flex;\r\n    gap: 30px;\r\n    border-radius: 14px;\r\n    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    padding: 10px;\r\n    margin-top: 20px;\r\n}\r\n\r\n.cardBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    min-width: 180px;\r\n}\r\n\r\n.cardBoxInfo>span {\r\n    color: #0054E6;\r\n    font-size: 45px;\r\n    font-weight: bold;\r\n    margin-right: 10px;\r\n}\r\n.cardBoxInfo {\r\n    color: #0054E6;\r\n    margin-bottom: 0;\r\n}\r\n.sign {\r\n    color: #5576ad;\r\n    font-size: 35px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n     margin-right: 10px;\r\n}\r\n.textDescription {\r\n    display: flex;\r\n    color: #4b5863;\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n}\r\n\r\n.claimContainer {\r\n    margin-top: 40px;\r\n    display: flex;\r\n    gap: 40px;\r\n}\r\n\r\n.rightBox {\r\n     border-radius: 14px;\r\n    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    padding: 20px;\r\n}\r\n.rightBox>.textBox {\r\n    font-weight: bold;\r\n}\r\n.textColor {\r\n    color: #0054E6;\r\n    font-size: 20px;\r\n    text-align: center;\r\n}\r\n\r\n.infoBox {\r\n    margin: 20px 0;\r\n    display: flex;\r\n    gap: 20px;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #e6ebfc;\r\n    border-radius: 20px;\r\n    padding: 15px;\r\n}\r\n\r\n.infoBox>div>p>span {\r\n    font-weight: bold;\r\n}\r\n\r\n.icon>svg {\r\n    color: #0054E6;\r\n    font-size: 35px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerBox": `ClientPanel-module__headerBox--caM2M`,
	"cardBox": `ClientPanel-module__cardBox--GQihl`,
	"cardBoxInfo": `ClientPanel-module__cardBoxInfo--wM8fh`,
	"sign": `ClientPanel-module__sign--kXNwG`,
	"textDescription": `ClientPanel-module__textDescription--zkwrT`,
	"claimContainer": `ClientPanel-module__claimContainer--EdIr_`,
	"rightBox": `ClientPanel-module__rightBox--ZRNWm`,
	"textBox": `ClientPanel-module__textBox--WRZ9r`,
	"textColor": `ClientPanel-module__textColor--g7w8P`,
	"infoBox": `ClientPanel-module__infoBox--nc8ga`,
	"icon": `ClientPanel-module__icon--OTied`
};
export default ___CSS_LOADER_EXPORT___;
